(function ($) {
  'use strict';

  function initAjaxCart() {
    var settingsEl = document.querySelector('[data-ajax-cart-settings]');
    var $cart = $('[data-ajax-cart]');

    if (!$cart.length) {
      return;
    }

    var settings = {
      enabled: true,
      freeShippingThreshold: 8900,
      freeShippingProgressMessage: "You're {{ amount }} away from free shipping!",
      freeShippingQualifiedMessage: "You've unlocked free shipping!",
      moneyFormat: '${{amount}}',
      enableOrderNotes: true,
      inventoryEndpoint: 'https://jones-app.rndpxl.net',
      stockLimitMessage: '',
      productUrls: {},
      variantUrls: {},
      parentProductUrl: ''
    };

    if (settingsEl) {
      try {
        settings = $.extend(settings, JSON.parse(settingsEl.textContent));
      } catch (error) {
        console.error('Ajax cart settings could not be parsed.', error);
      }
    }

    if (settings.enabled === false) {
      return;
    }

    var $document = $(document);
    var $items = $('[data-ajax-cart-items]');
    var $empty = $('[data-ajax-cart-empty]');
  var $footer = $('[data-ajax-cart-footer]');
  var $subtotal = $('[data-ajax-cart-subtotal]');
  var $compareTotal = $('[data-ajax-cart-compare-total]');
  var $count = $('[data-ajax-cart-count]');
  var $savings = $('[data-ajax-cart-savings]');
  var $savingsAmount = $('[data-ajax-cart-savings-amount]');
  var $shippingBar = $('[data-ajax-cart-shipping-bar]');
  var $shippingMessage = $('[data-ajax-cart-shipping-message]');
  var $shippingProgress = $('[data-ajax-cart-shipping-progress]');
  var $checkoutWrap = $('[data-ajax-cart-checkout-wrap]');
  var $checkoutButton = $('[data-ajax-cart-checkout]');
  var $checkoutProgress = $checkoutButton.find('.progress');
  var $noteField = $('[data-ajax-cart-note]');
  var $noteStatus = $('[data-ajax-cart-note-status]');
  var $noteToggle = $('[data-ajax-cart-ordernote-toggle]');
  var $notePanel = $('[data-ajax-cart-ordernote-panel]');
  var $reviewConfirm = $('[data-ajax-cart-review]');
  var $reviewCheckbox = $('[data-ajax-cart-review-checkbox]');
  var $inventoryModal = $('[data-ajax-cart-inventory-modal]');
  var $inventoryAdjustments = $('[data-ajax-cart-inventory-adjustments]');
  var $cartBody = $cart.find('[data-ajax-cart-body]');
  var $summary = $cart.find('[data-ajax-cart-summary]');
  var $summaryToggle = $cart.find('[data-ajax-cart-summary-toggle]');
  var $header = $('.site-header-wrapper');
  var isOpen = false;
  var summaryManuallyExpanded = false;
  var drawerChromeFrame = null;
  var drawerChromeLockTimer = null;
  var drawerChromeLocked = false;
  var SCROLL_TOP_THRESHOLD = 8;
  var CHROME_TRANSITION_MS = 280;
  var COLLAPSE_OVERFLOW_BUFFER = 16;
  var COLLAPSED_ITEMS_PADDING_BUMP = 8;
  var isUpdating = false;
  var updateToken = 0;
  var cartTaskQueue = $.Deferred().resolve().promise();
  var noteSaveTimer = null;
  var inventoryChecked = false;
  var pendingCheckout = false;
  var INVENTORY_TIMEOUT_MS = 8000;
  var PRODUCT_CONFIRM_TIMEOUT_MS = 5000;
  var currentCart = window._cart || { item_count: 0, items: [], total_price: 0 };
  var PRODUCT_URL_STORAGE_KEY = 'ajaxCartProductUrls';
  var PARENT_URL_PROPERTY = '_parent_url';
  var productUrlMap = {};
  var variantUrlMap = {};
  var saleDeltaByHandle = {};
  var saleDeltaByProduct = {};
  var compareAtFetches = {};

  function isReviewRequired() {
    return $reviewConfirm.length > 0;
  }

  function isReviewConfirmed() {
    if (!isReviewRequired()) {
      return true;
    }

    return $reviewCheckbox.prop('checked') === true;
  }

  function highlightReviewStep() {
    if (!$reviewConfirm.length) {
      return;
    }

    $reviewConfirm.addClass('is-highlighted');
    $reviewConfirm[0].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function normalizeProductUrl(url) {
    if (!url) {
      return '';
    }

    var value = String(url).trim();

    if (!value) {
      return '';
    }

    if (value.indexOf('/') === -1 && value.indexOf('http') !== 0) {
      return '/products/' + value;
    }

    return value.split('?')[0].split('#')[0];
  }

  function assignUrlToMap(map, id, url, overwrite) {
    var normalized = normalizeProductUrl(url);

    if (!id || !normalized) {
      return false;
    }

    var key = String(id);

    if (!overwrite && map[key]) {
      return false;
    }

    map[key] = normalized;
    return true;
  }

  function loadProductUrlMap() {
    try {
      var storedRaw = localStorage.getItem(PRODUCT_URL_STORAGE_KEY) || sessionStorage.getItem(PRODUCT_URL_STORAGE_KEY) || '{}';
      var stored = JSON.parse(storedRaw) || {};

      if (stored.products || stored.variants) {
        productUrlMap = stored.products || {};
        variantUrlMap = stored.variants || {};
      } else {
        productUrlMap = stored;
        variantUrlMap = {};
      }
    } catch (error) {
      productUrlMap = {};
      variantUrlMap = {};
    }

    mergeSeededUrls(settings.productUrls, productUrlMap);
    mergeSeededUrls(settings.variantUrls, variantUrlMap);
    harvestProductUrlsFromDom();
    seedUrlsFromCurrentProduct();
    saveProductUrlMap();
  }

  function mergeSeededUrls(source, target) {
    var seededUrls = source || {};

    Object.keys(seededUrls).forEach(function (id) {
      assignUrlToMap(target, id, seededUrls[id], true);
    });
  }

  function saveProductUrlMap() {
    var payload = JSON.stringify({
      products: productUrlMap,
      variants: variantUrlMap
    });

    try {
      localStorage.setItem(PRODUCT_URL_STORAGE_KEY, payload);
    } catch (error) {
      try {
        sessionStorage.setItem(PRODUCT_URL_STORAGE_KEY, payload);
      } catch (storageError) {
        // Ignore storage failures (private mode, quota, etc.)
      }
    }
  }

  function registerProductUrl(productId, url) {
    if (assignUrlToMap(productUrlMap, productId, url, true)) {
      saveProductUrlMap();
    }
  }

  function registerVariantUrl(variantId, url) {
    registerVariantUrls([variantId], url);
  }

  function registerVariantUrls(variantIds, url) {
    var parentUrl = normalizeProductUrl(url);
    var changed = false;

    if (!parentUrl || !variantIds || !variantIds.length) {
      return;
    }

    variantIds.forEach(function (variantId) {
      if (assignUrlToMap(variantUrlMap, variantId, parentUrl, true)) {
        changed = true;
      }
    });

    if (changed) {
      saveProductUrlMap();
    }
  }

  function rememberParentUrlForItems(items, productUrl) {
    var parentUrl = normalizeProductUrl(productUrl);

    if (!parentUrl || !items || !items.length) {
      return;
    }

    items.forEach(function (item) {
      assignUrlToMap(variantUrlMap, item.id || item.variant_id, parentUrl, true);
    });

    saveProductUrlMap();
  }

  function harvestProductUrlsFromDom() {
    $items.find('[data-ajax-cart-item]').each(function () {
      var $item = $(this);
      var url = $item.attr('data-product-url');

      assignUrlToMap(productUrlMap, $item.attr('data-product-id'), url, false);
      assignUrlToMap(variantUrlMap, $item.attr('data-cartitem-id'), url, false);
    });
  }

  function parseCompareAtCents(cents) {
    var value = parseInt(cents, 10);
    if (isNaN(value) || value < 0) {
      return 0;
    }
    return value;
  }

  function handleFromProductUrl(url) {
    if (!url) {
      return '';
    }

    var match = String(url).match(/\/products\/([^/?#]+)/i);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function rememberSaleDelta(handle, productId, cents) {
    var value = parseCompareAtCents(cents);

    if (handle) {
      var handleKey = String(handle);
      if (!(value <= 0 && saleDeltaByHandle[handleKey] > 0)) {
        saleDeltaByHandle[handleKey] = value;
      }
    }

    if (productId) {
      var productKey = String(productId);
      if (!(value <= 0 && saleDeltaByProduct[productKey] > 0)) {
        saleDeltaByProduct[productKey] = value;
      }
    }
  }

  function getProductPriceStats(product) {
    var variants = (product && product.variants) || [];
    var baseVariant = null;
    var minPrice = 0;

    variants.forEach(function (variant) {
      var price = parseCompareAtCents(variant && variant.price);

      if (price > 0 && (!baseVariant || price < minPrice)) {
        minPrice = price;
        baseVariant = variant;
      }
    });

    if (!baseVariant) {
      minPrice = parseCompareAtCents(product && (product.price || product.price_min));
    }

    var minCompareAt = parseCompareAtCents(baseVariant && baseVariant.compare_at_price);

    if (minCompareAt <= 0) {
      minCompareAt = parseCompareAtCents(
        product && (product.compare_at_price || product.compare_at_price_min)
      );
    }

    return {
      minPrice: minPrice,
      minCompareAt: minCompareAt,
      saleDelta: Math.max(0, minCompareAt - minPrice)
    };
  }

  function getSaleDeltaForItem(item) {
    var handle = getItemParentHandle(item);

    if (handle && Object.prototype.hasOwnProperty.call(saleDeltaByHandle, handle)) {
      return saleDeltaByHandle[handle];
    }

    if (item && item.product_id && Object.prototype.hasOwnProperty.call(saleDeltaByProduct, String(item.product_id))) {
      return saleDeltaByProduct[String(item.product_id)];
    }

    return 0;
  }

  function hasSaleDelta(item) {
    return getSaleDeltaForItem(item) > 0;
  }

  function applyParentSaleDelta(handle, cart, product) {
    if (!product) {
      return;
    }

    var stats = getProductPriceStats(product);
    var productHandle = product.handle || handle || '';

    rememberSaleDelta(productHandle, product.id, stats.saleDelta);

    if (handle && handle !== productHandle) {
      rememberSaleDelta(handle, product.id, stats.saleDelta);
    }

    ((cart && cart.items) || (currentCart && currentCart.items) || []).forEach(function (item) {
      var itemHandle = getItemParentHandle(item);
      if (itemHandle === handle || itemHandle === productHandle) {
        rememberSaleDelta(itemHandle, item.product_id, stats.saleDelta);
      }
    });
  }

  function getItemParentHandle(item) {
    if (!item) {
      return '';
    }

    return (
      handleFromProductUrl(getProductUrl(item)) ||
      handleFromProductUrl(item.url) ||
      item.handle ||
      ''
    );
  }

  function seedCompareAtFromSettings() {
    var seededDeltas = settings.saleDeltaByHandle || {};

    Object.keys(seededDeltas).forEach(function (handle) {
      rememberSaleDelta(handle, null, seededDeltas[handle]);
    });
  }

  function seedCompareAtFromProduct() {
    if (!window._product) {
      return;
    }

    var product = window._product;
    var parentHandle = handleFromProductUrl(settings.parentProductUrl) || product.handle || '';
    var stats = getProductPriceStats(product);

    if (
      stats.saleDelta <= 0 &&
      product.handle &&
      parentHandle &&
      product.handle !== parentHandle
    ) {
      return;
    }

    applyParentSaleDelta(parentHandle || product.handle, currentCart, product);
  }

  function harvestCompareAtFromDom() {
    $items.find('[data-ajax-cart-item]').each(function () {
      var $item = $(this);
      var productId = $item.attr('data-product-id');
      var parentHandle = $item.attr('data-parent-handle');
      var saleDeltaAttr = $item.attr('data-sale-delta');

      if (saleDeltaAttr === undefined || saleDeltaAttr === null || saleDeltaAttr === '') {
        return;
      }

      rememberSaleDelta(parentHandle, productId, saleDeltaAttr);
    });
  }

  function fetchProductCompareAt(handle) {
    if (!handle) {
      return $.Deferred().resolve(null).promise();
    }

    if (compareAtFetches[handle]) {
      return compareAtFetches[handle];
    }

    compareAtFetches[handle] = $.getJSON('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (product) {
        applyParentSaleDelta(product && product.handle ? product.handle : handle, currentCart, product);
        applyParentSaleDelta(handle, currentCart, product);
        return product;
      }, function () {
        return null;
      });

    return compareAtFetches[handle];
  }

  function ensureCompareAtPrices(cart) {
    var handles = {};

    (cart && cart.items || []).forEach(function (item) {
      if (hasSaleDelta(item)) {
        return;
      }

      var handle = getItemParentHandle(item);
      if (handle) {
        handles[handle] = true;
      }
    });

    var requests = Object.keys(handles).map(fetchProductCompareAt);

    if (!requests.length) {
      return $.Deferred().resolve(false).promise();
    }

    return $.when.apply($, requests).then(function () {
      return true;
    });
  }

  function getItemOriginalUnitPrice(item) {
    return item.original_price || item.price || 0;
  }

  function getItemCompareAtPrice(item) {
    var saleDelta = getSaleDeltaForItem(item);

    if (saleDelta <= 0) {
      return 0;
    }

    return getItemOriginalUnitPrice(item) + saleDelta;
  }

  function getItemSaleSavings(item) {
    var saleDelta = getSaleDeltaForItem(item);

    if (saleDelta <= 0) {
      return 0;
    }

    return saleDelta * (item.quantity || 0);
  }

  function getItemWasUnitPrice(item) {
    return Math.max(getItemCompareAtPrice(item), getItemOriginalUnitPrice(item));
  }

  function getItemWasLinePrice(item) {
    return getItemWasUnitPrice(item) * (item.quantity || 0);
  }

  function getCartSaleSavings(cart) {
    var total = 0;

    (cart.items || []).forEach(function (item) {
      total += getItemSaleSavings(item);
    });

    return total;
  }

  function getCartCompareTotal(cart) {
    var total = 0;

    (cart.items || []).forEach(function (item) {
      total += getItemWasLinePrice(item);
    });

    return total;
  }

  function itemIsOnSale(item) {
    return getSaleDeltaForItem(item) > 0;
  }

  function getItemTierSavings(item) {
    if (itemIsOnSale(item)) {
      return 0;
    }

    return Math.max(0, (item.original_line_price || 0) - (item.final_line_price || 0));
  }

  function addPromoAmount(map, title, amount) {
    var key = title || 'Tier discount';
    var value = amount || 0;

    if (value <= 0) {
      return;
    }

    map[key] = (map[key] || 0) + value;
  }

  function getPromoSavings(cart) {
    var byTitle = {};
    var namedTotal = 0;

    (cart.items || []).forEach(function (item) {
      if (itemIsOnSale(item)) {
        return;
      }

      var allocations = item.line_level_discount_allocations;

      if (allocations && allocations.length) {
        allocations.forEach(function (allocation) {
          var title = allocation.discount_application
            ? allocation.discount_application.title
            : allocation.title;
          addPromoAmount(byTitle, title, allocation.amount);
          namedTotal += allocation.amount || 0;
        });
        return;
      }

      (item.discounts || []).forEach(function (discount) {
        addPromoAmount(byTitle, discount.title, discount.amount);
        namedTotal += discount.amount || 0;
      });
    });

    var tierTotal = calculateCartSavings(cart);

    if (tierTotal > namedTotal) {
      addPromoAmount(
        byTitle,
        Object.keys(byTitle).length ? 'Discount' : 'Tier discount',
        tierTotal - namedTotal
      );
    }

    return {
      byTitle: byTitle,
      total: tierTotal
    };
  }

  function seedUrlsFromCurrentProduct() {
    var parentUrl = normalizeProductUrl(settings.parentProductUrl);

    if (!parentUrl) {
      return;
    }

    if (!window._product || !window._product.variants) {
      return;
    }

    window._product.variants.forEach(function (variant) {
      if (variant && variant.id) {
        assignUrlToMap(variantUrlMap, variant.id, parentUrl, true);
      }
    });
  }

  function getItemParentUrl(item) {
    var properties = item && item.properties;

    if (!properties) {
      return '';
    }

    return normalizeProductUrl(
      properties[PARENT_URL_PROPERTY] ||
      properties.parent_url ||
      ''
    );
  }

  function rememberResolvedProductUrl(item, url) {
    if (!item || !url) {
      return;
    }

    assignUrlToMap(productUrlMap, item.product_id, url, true);
    assignUrlToMap(variantUrlMap, item.variant_id, url, true);
  }

  function getProductUrl(item) {
    var fromProps = getItemParentUrl(item);

    if (fromProps) {
      rememberResolvedProductUrl(item, fromProps);
      return fromProps;
    }

    var fromProduct = productUrlMap[String(item.product_id)];

    if (fromProduct) {
      rememberResolvedProductUrl(item, fromProduct);
      return fromProduct;
    }

    var fromVariant = variantUrlMap[String(item.variant_id)];

    if (fromVariant) {
      rememberResolvedProductUrl(item, fromVariant);
      return fromVariant;
    }

    return item.url;
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, settings.moneyFormat);
    }

    return (cents / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD'
    });
  }

  function escapeHtml(text) {
    var div = document.createElement('div');
    div.textContent = text || '';
    return div.innerHTML;
  }

  function normalizeColorName(colorName) {
    if (!colorName) {
      return null;
    }

    var normalized = String(colorName).replace(/\|/g, ' ').replace(/\s+/g, ' ').trim();
    return normalized || null;
  }

  function parseCartTitle(fullTitle) {
    if (!fullTitle) {
      return {
        title: '',
        color: null
      };
    }

    var splitAt = fullTitle.lastIndexOf(' | ');
    if (splitAt === -1) {
      splitAt = fullTitle.lastIndexOf('|');
    }

    if (splitAt === -1) {
      return {
        title: fullTitle.trim(),
        color: null
      };
    }

    return {
      title: fullTitle.slice(0, splitAt).trim(),
      color: normalizeColorName(fullTitle.slice(splitAt + 1))
    };
  }

  function getColorFromVariantOptions(item) {
    if (!item.variant_options || !item.options_with_values) {
      return null;
    }

    for (var i = 0; i < item.options_with_values.length; i++) {
      var option = item.options_with_values[i];
      var optionName = (option.name || '').toLowerCase();

      if (optionName === 'color' || optionName === 'colour') {
        return normalizeColorName(option.value);
      }
    }

    return null;
  }

  function resolveItemColor(item, parsedTitle) {
    return parsedTitle.color || getColorFromVariantOptions(item);
  }

  function isLightSwatch(colorName, hex) {
    var normalized = (normalizeColorName(colorName) || '').toLowerCase();

    if (normalized === 'white') {
      return true;
    }

    if (!hex) {
      return false;
    }

    var cleanHex = String(hex).replace('#', '').toLowerCase();
    return cleanHex === 'ffffff' || cleanHex === 'fff';
  }

  function getColorHex(colorName) {
    var normalized = normalizeColorName(colorName);

    if (!normalized || !window._colors || !window._colors.colors) {
      return null;
    }

    for (var i = 0; i < window._colors.colors.length; i++) {
      var paletteColor = window._colors.colors[i];

      if (
        paletteColor.t === normalized ||
        paletteColor.t.toLowerCase() === normalized.toLowerCase()
      ) {
        return paletteColor.h;
      }
    }

    return null;
  }

  function getColorLabelHtml(colorName) {
    var normalized = normalizeColorName(colorName);

    if (!normalized) {
      return '';
    }

    var hex = getColorHex(normalized);
    var style = hex ? ' style="background:#' + hex + ';"' : '';
    var swatchClass = 'ajax-cart-item__swatch' + (isLightSwatch(normalized, hex) ? ' ajax-cart-item__swatch--light' : '');

    return (
      '<div class="ajax-cart-item__color">' +
      '<span class="' + swatchClass + '"' + style + ' data-color="' + escapeHtml(normalized) + '"></span>' +
      '<span class="ajax-cart-item__color-name">' + escapeHtml(normalized) + '</span>' +
      '</div>'
    );
  }

  function applyColorSwatches() {
    $items.find('.ajax-cart-item__swatch').each(function () {
      var $swatch = $(this);
      var colorName = $swatch.attr('data-color');
      var hex = getColorHex(colorName);

      if (hex) {
        $swatch.css('background', '#' + hex);
      }

      $swatch.toggleClass('ajax-cart-item__swatch--light', isLightSwatch(colorName, hex));
    });
  }

  function resetReviewConfirmation() {
    if ($reviewCheckbox.length) {
      $reviewCheckbox.prop('checked', false);
    }

    if ($reviewConfirm.length) {
      $reviewConfirm.removeClass('is-highlighted');
    }

    updateCheckoutState();
  }

  function updateCheckoutState() {
    var inventoryReady = inventoryChecked;
    var reviewOk = isReviewConfirmed();
    var canProceed = inventoryReady && reviewOk;
    var reviewBlocked = isReviewRequired() && !reviewOk;

    $checkoutWrap.toggleClass('disabled', !inventoryReady);
    $checkoutWrap.toggleClass('is-review-blocked', inventoryReady && reviewBlocked);
    $checkoutButton.prop('disabled', !inventoryReady);
    $checkoutButton.toggleClass('ajax-cart__checkout--review-blocked', inventoryReady && reviewBlocked);
    $checkoutButton.attr('aria-disabled', canProceed ? 'false' : 'true');
  }

  function getDiscountHtml(item) {
    var allocations = item.line_level_discount_allocations || item.discounts || [];
    var html = '';
    var saleSavings = getItemSaleSavings(item);
    var onSale = itemIsOnSale(item);

    if (saleSavings > 0) {
      html +=
        '<span class="ajax-cart-item__discount ajax-cart-item__discount--sale">' +
        'On Sale (-' + formatMoney(saleSavings) + ')' +
        '</span>';
    }

    if (!onSale) {
      if (allocations.length) {
        html += allocations.map(function (allocation) {
          var title = allocation.discount_application
            ? allocation.discount_application.title
            : allocation.title;
          return (
            '<span class="ajax-cart-item__discount ajax-cart-item__discount--tier">' +
            escapeHtml(title) + ' (-' + formatMoney(allocation.amount) + ')' +
            '</span>'
          );
        }).join('');
      } else if (item.original_line_price !== item.final_line_price) {
        var fallbackAmount = item.original_line_price - item.final_line_price;
        html +=
          '<span class="ajax-cart-item__discount ajax-cart-item__discount--tier">' +
          'Tier discount (-' + formatMoney(fallbackAmount) + ')</span>';
      }
    }

    if (!html) {
      return '';
    }

    return '<div class="ajax-cart-item__discounts" data-cartitem-discounts>' + html + '</div>';
  }

  function getSizeFromVariantOptions(item, colorName) {
    var normalizedColor = normalizeColorName(colorName);

    if (item.options_with_values && item.options_with_values.length) {
      for (var i = 0; i < item.options_with_values.length; i++) {
        var option = item.options_with_values[i];
        var optionName = (option.name || '').toLowerCase();

        if (optionName === 'size') {
          return String(option.value || '').trim();
        }
      }
    }

    if (!item.variant_options || !item.variant_options.length) {
      return null;
    }

    for (var j = 0; j < item.variant_options.length; j++) {
      var variantOption = normalizeColorName(item.variant_options[j]) || String(item.variant_options[j]).trim();

      if (variantOption === 'Default Title') {
        continue;
      }

      if (!normalizedColor || variantOption !== normalizedColor) {
        return variantOption;
      }
    }

    return null;
  }

  function getVariantRowHtml(item, colorName) {
    var normalized = normalizeColorName(colorName);
    var size = getSizeFromVariantOptions(item, normalized);
    var colorHtml = getColorLabelHtml(normalized);
    var infoHtml = '<div class="ajax-cart-item__variant-info">';

    if (colorHtml) {
      infoHtml += colorHtml;
    }

    if (colorHtml && size) {
      infoHtml += '<span class="ajax-cart-item__variant-sep" aria-hidden="true">|</span>';
    }

    if (size) {
      infoHtml += '<span class="ajax-cart-item__size">' + escapeHtml(size) + '</span>';
    }

    if (colorHtml || size) {
      infoHtml += '<span class="ajax-cart-item__variant-sep" aria-hidden="true">|</span>';
    }

    var wasUnit = getItemWasUnitPrice(item);
    var finalUnit = item.final_price || item.price || 0;
    var unitHtml = '<span class="ajax-cart-item__unit-price">';

    if (wasUnit > finalUnit) {
      unitHtml +=
        '<span class="ajax-cart-item__compare-price money">' +
        formatMoney(wasUnit) +
        '</span>';
    }

    unitHtml += '<span class="money">' + formatMoney(finalUnit) + '</span></span>';
    infoHtml += unitHtml;

    infoHtml += '</div>';

    return (
      '<div class="ajax-cart-item__variant">' +
      infoHtml +
      getDiscountHtml(item) +
      '</div>'
    );
  }

  function getOtherOptionsHtml(item, colorName) {
    if (!item.variant_options || !item.variant_options.length) {
      return '';
    }

    if (item.variant_options.length === 1 && item.variant_options[0] === 'Default Title') {
      return '';
    }

    var normalizedColor = normalizeColorName(colorName);
    var size = getSizeFromVariantOptions(item, normalizedColor);
    var html = '';

    item.variant_options.forEach(function (option) {
      var normalizedOption = normalizeColorName(option) || String(option).trim();

      if (normalizedOption === 'Default Title') {
        return;
      }

      if (normalizedColor && normalizedOption === normalizedColor) {
        return;
      }

      if (size && normalizedOption === size) {
        return;
      }

      html +=
        '<div class="ajax-cart-item__option">' +
        escapeHtml(normalizedOption) +
        '</div>';
    });

    return html;
  }

  function getLineTotalHtml(item) {
    var html = '';
    var finalLine = item.final_line_price || 0;
    var wasLine = getItemWasLinePrice(item);

    if (wasLine > finalLine) {
      html +=
        '<span class="ajax-cart-item__original-total money" data-cartitem-original-total>' +
        formatMoney(wasLine) +
        '</span>';
    }

    html +=
      '<span class="money" data-cartitem-total>' +
      formatMoney(finalLine) +
      '</span>';

    return html;
  }

  function getRemoveButtonHtml(title) {
    return (
      '<button type="button" class="ajax-cart-item__remove" data-cartitem-remove ' +
      'aria-label="Remove ' + escapeHtml(title) + '">' +
      '<svg aria-hidden="true" focusable="false" role="presentation" width="10" height="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">' +
      '<path fill="currentColor" d="M6.08785659,5 L9.77469752,1.31315906 L8.68684094,0.225302476 L5,3.91214341 L1.31315906,0.225302476 L0.225302476,1.31315906 L3.91214341,5 L0.225302476,8.68684094 L1.31315906,9.77469752 L5,6.08785659 L8.68684094,9.77469752 L9.77469752,8.68684094 L6.08785659,5 Z"></path>' +
      '</svg></button>'
    );
  }

  function getQtyControlHtml(item) {
    return (
      '<div class="ajax-cart-item__qty">' +
      '<span class="ajax-cart-item__qty-label">Qty</span>' +
      '<div class="ajax-cart-item__qty-control">' +
      '<input class="ajax-cart-item__qty-input" value="' +
      item.quantity + '" type="tel" pattern="\\d*" min="0" aria-label="Quantity" ' +
      'data-quantity-input data-cartitem-quantity>' +
      '<div class="ajax-cart-item__qty-steppers">' +
      '<button type="button" class="ajax-cart-item__qty-step" data-cartitem-qty-decrease aria-label="Decrease quantity">−</button>' +
      '<button type="button" class="ajax-cart-item__qty-step" data-cartitem-qty-increase aria-label="Increase quantity">+</button>' +
      '</div></div></div>'
    );
  }

  function buildItemHtml(item) {
    var parsedTitle = parseCartTitle(item.product_title);
    var itemColor = resolveItemColor(item, parsedTitle);
    var imageHtml = item.image
      ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(parsedTitle.title) + '">'
      : '';
    var productUrl = getProductUrl(item);
    var parentHandle = getItemParentHandle(item);
    var compareAt = getItemCompareAtPrice(item);
    var saleDelta = getSaleDeltaForItem(item);

    return (
      '<article class="ajax-cart-item" data-ajax-cart-item data-cartitem data-cartitem-id="' +
      item.variant_id + '" data-cartitem-key="' + escapeHtml(item.key) +
      '" data-product-id="' + item.product_id +
      '" data-product-url="' + escapeHtml(productUrl) + '"' +
      (compareAt > 0 ? ' data-compare-at-price="' + compareAt + '"' : '') +
      ' data-sale-delta="' + saleDelta + '"' +
      (parentHandle ? ' data-parent-handle="' + escapeHtml(parentHandle) + '"' : '') +
      (itemColor ? ' data-item-color="' + escapeHtml(itemColor) + '"' : '') + '>' +
      '<figure class="ajax-cart-item__image">' +
      '<a href="' + escapeHtml(productUrl) + '">' + imageHtml + '</a>' +
      getRemoveButtonHtml(parsedTitle.title) +
      '</figure>' +
      '<div class="ajax-cart-item__details">' +
      '<div class="ajax-cart-item__meta">' +
      '<h3 class="ajax-cart-item__title">' +
      '<a href="' + escapeHtml(productUrl) + '">' + escapeHtml(parsedTitle.title) + '</a>' +
      '</h3>' +
      getVariantRowHtml(item, itemColor) +
      getOtherOptionsHtml(item, itemColor) +
      '</div>' +
      '<div class="ajax-cart-item__controls">' +
      getQtyControlHtml(item) +
      '<div class="ajax-cart-item__total">' + getLineTotalHtml(item) + '</div>' +
      '</div></div></article>'
    );
  }

  function buildAdjustmentItemHtml(item, originalQuantity, newQuantity) {
    var reason = newQuantity === 0
      ? 'Out of stock (removed)'
      : 'Quantity reduced to ' + newQuantity;
    var parsedTitle = parseCartTitle(item.product_title);
    var itemColor = resolveItemColor(item, parsedTitle);

    return (
      '<article class="ajax-cart-item">' +
      '<figure class="ajax-cart-item__image">' +
      (item.image ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.product_title) + '">' : '') +
      '</figure>' +
      '<div class="ajax-cart-item__details">' +
      '<div class="ajax-cart-item__meta">' +
      '<h3 class="ajax-cart-item__title">' + escapeHtml(parsedTitle.title) + '</h3>' +
      getVariantRowHtml(item, itemColor) +
      getOtherOptionsHtml(item, itemColor) +
      '</div>' +
      '<div class="ajax-cart-item__controls ajax-cart-item__controls--adjustment">' +
      '<div class="quantity-adjustment">' +
      '<label>Quantity<span>' + originalQuantity + '</span></label>' +
      '<p>' + reason + '</p>' +
      '</div></div></div></article>'
    );
  }

  function updateShippingBar(cart) {
    var threshold = settings.freeShippingThreshold || 8900;
    var subtotal = cart.total_price || 0;
    var remaining = Math.max(threshold - subtotal, 0);
    var progress = Math.min((subtotal / threshold) * 100, 100);

    if (!cart.item_count) {
      $shippingBar.attr('hidden', true);
      return;
    }

    $shippingBar.removeAttr('hidden');

    if (remaining <= 0) {
      $shippingMessage.text(settings.freeShippingQualifiedMessage);
      $shippingProgress.css('width', '100%');
      $shippingBar.addClass('is-qualified');
    } else {
      var message = settings.freeShippingProgressMessage.replace(
        '{{ amount }}',
        formatMoney(remaining)
      );
      $shippingMessage.text(message);
      $shippingProgress.css('width', progress + '%');
      $shippingBar.removeClass('is-qualified');
    }
  }

  function calculateCartSavings(cart) {
    var lineSavings = 0;
    var items = (cart && cart.items) || [];

    for (var i = 0; i < items.length; i++) {
      lineSavings += getItemTierSavings(items[i]);
    }

    return lineSavings;
  }

  function updateTotals(cart) {
    currentCart = cart;
    window._cart = cart;

    var saleSavings = getCartSaleSavings(cart);
    var promoSavings = getPromoSavings(cart);
    var savings = saleSavings + promoSavings.total;
    var compareTotal = getCartCompareTotal(cart);

    $subtotal.html(formatMoney(cart.total_price));
    $count.text(cart.item_count);

    if (compareTotal > cart.total_price) {
      $compareTotal.html(formatMoney(compareTotal)).removeAttr('hidden');
    } else {
      $compareTotal.attr('hidden', 'hidden').empty();
    }

    if (savings > 0) {
      $savings.removeAttr('hidden');
      $savingsAmount.html(formatMoney(savings));
    } else {
      $savings.attr('hidden', 'hidden');
      $savingsAmount.empty();
    }

    updateShippingBar(cart);

    if ($noteField.length && typeof cart.note === 'string' && document.activeElement !== $noteField[0]) {
      $noteField.val(cart.note);

      if (cart.note.trim().length) {
        $noteToggle.attr('aria-expanded', 'true').addClass('is-open');
        $notePanel.prop('hidden', false);
      }
    }

    setEmptyState(!cart.item_count);
  }

  function setEmptyState(isEmpty) {
    $cart.toggleClass('is-empty', !!isEmpty);

    if (isEmpty) {
      $footer.attr('hidden', true);
      $items.attr('hidden', true);
      $empty.removeAttr('hidden');
      $count.attr('hidden', true);
      return;
    }

    $footer.removeAttr('hidden');
    $items.removeAttr('hidden');
    $empty.attr('hidden', true);
    $count.removeAttr('hidden');
  }

  function renderCart(cart, options) {
    options = options || {};
    harvestProductUrlsFromDom();
    harvestCompareAtFromDom();

    if (!cart.items || !cart.items.length) {
      $items.empty();
    } else {
      $items.html(cart.items.map(buildItemHtml).join(''));
    }

    saveProductUrlMap();
    updateTotals(cart);
    applyColorSwatches();
    scheduleDrawerChromeSync();

    if (options.skipCompareAtFetch) {
      return;
    }

    ensureCompareAtPrices(cart).then(function (didUpdate) {
      if (didUpdate && currentCart && currentCart.items) {
        renderCart(currentCart, { skipCompareAtFetch: true });
      }
    });
  }

  function setCheckoutLoading(loading) {
    $checkoutButton.toggleClass('loading disabled', loading);
    if (!loading) {
      updateCheckoutState();
    }
  }

  function setCheckoutProgress(percent) {
    $checkoutProgress.css('width', percent + '%');
  }

  function markInventoryStale() {
    inventoryChecked = false;
    updateCheckoutState();
  }

  function enqueueCartTask(task) {
    var run = cartTaskQueue.then(function () {
      return task();
    });

    cartTaskQueue = run.then(function () {
      return null;
    }, function () {
      return null;
    });

    return run;
  }

  function delay(ms) {
    var deferred = $.Deferred();
    setTimeout(function () {
      deferred.resolve();
    }, ms);
    return deferred.promise();
  }

  function refreshCart() {
    return $.getJSON('/cart.js').then(function (cart) {
      renderCart(cart);
      $header.trigger('cartcount:update', { response: cart });
      return cart;
    });
  }

  function getCartQuantityMap(cart) {
    var map = {};

    if (!cart || !cart.items) {
      return map;
    }

    cart.items.forEach(function (item) {
      var id = String(item.variant_id);
      map[id] = (map[id] || 0) + item.quantity;
    });

    return map;
  }

  function normalizeAddItems(items) {
    var merged = {};
    var order = [];

    items.forEach(function (item) {
      var id = parseInt(item.id, 10);
      var quantity = parseInt(item.quantity, 10) || 0;

      if (!id || quantity <= 0) {
        return;
      }

      if (!merged[id]) {
        order.push(id);
        merged[id] = 0;
      }

      merged[id] += quantity;
    });

    return order.map(function (id) {
      return {
        id: id,
        quantity: merged[id]
      };
    });
  }

  function getMissingAddItems(requestedItems, priorQuantities, cartQuantities) {
    var missing = [];

    requestedItems.forEach(function (item) {
      var id = String(item.id);
      var expected = (priorQuantities[id] || 0) + item.quantity;
      var actual = cartQuantities[id] || 0;

      if (actual < expected) {
        missing.push({
          id: item.id,
          quantity: expected - actual
        });
      }
    });

    return missing;
  }

  function splitAddItems(items, priorQuantities) {
    var existing = [];
    var novel = [];

    items.forEach(function (item) {
      if ((priorQuantities[String(item.id)] || 0) > 0) {
        existing.push(item);
      } else {
        novel.push(item);
      }
    });

    return {
      existing: existing,
      novel: novel
    };
  }

  function postCartAddItems(items) {
    if (!items.length) {
      return $.Deferred().resolve().promise();
    }

    if (items.length === 1) {
      return $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: {
          id: items[0].id,
          quantity: items[0].quantity
        }
      });
    }

    var data = {};
    items.forEach(function (item, index) {
      data['items[' + index + '][id]'] = item.id;
      data['items[' + index + '][quantity]'] = item.quantity;
    });

    return $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: data
    });
  }

  function postCartUpdates(updates) {
    var ids = Object.keys(updates || {});

    if (!ids.length) {
      return $.Deferred().resolve().promise();
    }

    var data = {};
    ids.forEach(function (id) {
      data['updates[' + id + ']'] = updates[id];
    });

    return $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      dataType: 'json',
      data: data
    });
  }

  function addItemsSequentially(items, productUrl) {
    var chain = $.Deferred().resolve().promise();

    items.forEach(function (item) {
      chain = chain.then(function () {
        return postCartAddItems([item]).then(null, function () {
          return $.Deferred().resolve().promise();
        });
      });
    });

    return chain;
  }

  function getAddedItemsFromResponse(response) {
    if (!response) {
      return [];
    }

    if ($.isArray(response)) {
      return response;
    }

    if (response.items) {
      return response.items;
    }

    if (response.product_id || response.variant_id) {
      return [response];
    }

    return [];
  }

  function registerProductUrlsFromAddResponse(response, productUrl) {
    var parentUrl = normalizeProductUrl(productUrl);

    if (!parentUrl) {
      return;
    }

    getAddedItemsFromResponse(response).forEach(function (item) {
      if (!item) {
        return;
      }

      registerProductUrl(item.product_id, parentUrl);
      registerVariantUrl(item.variant_id || item.id, parentUrl);
    });
  }

  function registerProductUrlsFromCart(cart, productUrl, variantIds) {
    var parentUrl = normalizeProductUrl(productUrl);

    if (!parentUrl || !cart || !cart.items) {
      return;
    }

    var idSet = {};
    (variantIds || []).forEach(function (id) {
      idSet[String(id)] = true;
    });

    var hasFilter = Object.keys(idSet).length > 0;

    cart.items.forEach(function (item) {
      if (hasFilter && !idSet[String(item.variant_id)] && !idSet[String(item.id)]) {
        return;
      }

      rememberResolvedProductUrl(item, parentUrl);
    });

    saveProductUrlMap();
  }

  function showUnaddedItemsMessage(missing) {
    if (!missing.length) {
      return;
    }

    $cart.find('[data-ajax-cart-error]').remove();
    $footer.prepend(
      '<div class="ajax-cart__error" data-ajax-cart-error role="alert">' +
      'Some sizes could not be added to your cart. Please check quantities and try again.' +
      '</div>'
    );
    console.warn('Ajax cart could not add all requested items.', missing);
  }

  function readCartState(requestedItems, priorQuantities) {
    return $.getJSON('/cart.js').then(function (cart) {
      return {
        cart: cart,
        missing: getMissingAddItems(requestedItems, priorQuantities, getCartQuantityMap(cart))
      };
    });
  }

  function waitForCartToReflect(requestedItems, priorQuantities, attempt) {
    attempt = attempt || 0;

    return readCartState(requestedItems, priorQuantities).then(function (result) {
      if (!result.missing.length || attempt >= 5) {
        return result;
      }

      return delay(120 * (attempt + 1)).then(function () {
        return waitForCartToReflect(requestedItems, priorQuantities, attempt + 1);
      });
    });
  }

  function confirmMissingItems(requestedItems, priorQuantities) {
    return readCartState(requestedItems, priorQuantities).then(function (first) {
      if (!first.missing.length) {
        return first;
      }

      return delay(200).then(function () {
        return readCartState(requestedItems, priorQuantities);
      }).then(function (second) {
        return second.missing.length ? second : first;
      });
    });
  }

  function applyExistingQuantities(existingItems, priorQuantities) {
    if (!existingItems.length) {
      return $.Deferred().resolve().promise();
    }

    var updates = {};
    existingItems.forEach(function (item) {
      updates[item.id] = (priorQuantities[String(item.id)] || 0) + item.quantity;
    });

    return postCartUpdates(updates);
  }

  function addNovelItems(novelItems, productUrl) {
    if (!novelItems.length) {
      return $.Deferred().resolve().promise();
    }

    return postCartAddItems(novelItems).then(function (response) {
      registerProductUrlsFromAddResponse(response, productUrl);
      return response;
    }, function () {
      return addItemsSequentially(novelItems, productUrl);
    });
  }

  function addItemsNow(items, options) {
    options = options || {};
    var parentUrl = normalizeProductUrl(options.productUrl);
    var normalizedItems = normalizeAddItems(items || []);
    var variantIds = normalizedItems.map(function (item) {
      return item.id;
    });

    if (!normalizedItems.length) {
      return $.Deferred().resolve(currentCart).promise();
    }

    rememberParentUrlForItems(normalizedItems, parentUrl);
    seedCompareAtFromProduct();
    setUpdating(true);
    $cart.find('[data-ajax-cart-error]').remove();

    return $.getJSON('/cart.js').then(function (initialCart) {
      var priorQuantities = getCartQuantityMap(initialCart);
      var groups = splitAddItems(normalizedItems, priorQuantities);

      return applyExistingQuantities(groups.existing, priorQuantities)
        .then(function () {
          return addNovelItems(groups.novel, parentUrl);
        }, function () {
          return addItemsSequentially(groups.existing.concat(groups.novel), parentUrl);
        })
        .then(function () {
          return waitForCartToReflect(normalizedItems, priorQuantities);
        })
        .then(function (result) {
          if (!result.missing.length) {
            return result;
          }

          return confirmMissingItems(normalizedItems, priorQuantities).then(function (confirmed) {
            if (!confirmed.missing.length) {
              return confirmed;
            }

            return addItemsSequentially(confirmed.missing, parentUrl).then(function () {
              return waitForCartToReflect(normalizedItems, priorQuantities);
            });
          });
        })
        .then(function (result) {
          var cart = result.cart;

          if (result.missing && result.missing.length) {
            showUnaddedItemsMessage(result.missing);
          }

          if (cart) {
            registerProductUrlsFromCart(cart, parentUrl, variantIds);
            renderCart(cart);
            markInventoryStale();
            $header.trigger('cartcount:update', { response: cart });
          }

          return cart;
        });
    }).then(function (cart) {
      setUpdating(false);
      return cart;
    }, function (error) {
      setUpdating(false);
      return $.Deferred().reject(error).promise();
    });
  }

  function addItems(items, options) {
    return enqueueCartTask(function () {
      return addItemsNow(items, options);
    });
  }

  function setUpdating(state) {
    isUpdating = state;
    $cart.toggleClass('is-updating', state);
    $items.find('[data-cartitem-quantity], [data-cartitem-remove], [data-cartitem-qty-increase], [data-cartitem-qty-decrease]').prop('disabled', state);
  }

  function showStockLimitMessage(limit, title) {
    var message = (settings.stockLimitMessage || '')
      .replace('** quantity **', limit)
      .replace('** title **', title);

    if (!message) {
      return;
    }

    $cart.find('[data-ajax-cart-error]').remove();
    $footer.prepend(
      '<div class="ajax-cart__error" data-ajax-cart-error role="alert">' +
      escapeHtml(message) +
      '</div>'
    );
  }

  function changeItemNow(variantId, quantity) {
    var currentToken = ++updateToken;
    var requestedQuantity = quantity;
    setUpdating(true);
    markInventoryStale();

    return $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      dataType: 'json',
      data: {
        id: variantId,
        quantity: Math.max(quantity, 0)
      }
    })
      .then(function (cart) {
        if (currentToken !== updateToken) {
          return cart;
        }

        var adjustedItem = null;
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].variant_id === variantId) {
            adjustedItem = cart.items[i];
            break;
          }
        }

        if (
          adjustedItem &&
          requestedQuantity > 0 &&
          adjustedItem.quantity !== requestedQuantity
        ) {
          showStockLimitMessage(adjustedItem.quantity, adjustedItem.product_title);
        }

        renderCart(cart);
        $header.trigger('cartcount:update', { response: cart });
        resetReviewConfirmation();
        return checkInventoryNow(false);
      }, function () {
        return refreshCart();
      })
      .then(function (cart) {
        if (currentToken === updateToken) {
          setUpdating(false);
        }
        return cart;
      }, function (error) {
        if (currentToken === updateToken) {
          setUpdating(false);
        }
        return $.Deferred().reject(error).promise();
      });
  }

  function changeItem(variantId, quantity) {
    return enqueueCartTask(function () {
      return changeItemNow(variantId, quantity);
    });
  }

  function saveCartNote(note) {
    if (!settings.enableOrderNotes) {
      return $.Deferred().resolve().promise();
    }

    $noteStatus.removeAttr('hidden').text('Saving...');

    return $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      dataType: 'json',
      contentType: 'application/json',
      data: JSON.stringify({ note: note })
    })
      .done(function (cart) {
        currentCart = cart;
        window._cart = cart;
        $noteStatus.text('Saved');
        setTimeout(function () {
          $noteStatus.attr('hidden', true);
        }, 1500);
      })
      .fail(function () {
        $noteStatus.text('Could not save note');
      });
  }

  function openInventoryModal() {
    $inventoryModal.removeAttr('hidden').addClass('show');
  }

  function closeInventoryModal() {
    $inventoryModal.removeClass('show').attr('hidden', true);
  }

  function readReportedStock(variants, variantId) {
    if (!variants || typeof variants !== 'object') {
      return null;
    }

    if (
      !Object.prototype.hasOwnProperty.call(variants, variantId) &&
      !Object.prototype.hasOwnProperty.call(variants, String(variantId))
    ) {
      return null;
    }

    var stock = variants[variantId];
    if (typeof stock === 'string' && stock.trim() !== '') {
      stock = Number(stock);
    }

    if (typeof stock !== 'number' || !isFinite(stock) || stock < 0) {
      return null;
    }

    return stock;
  }

  function collectInventoryAdjustments(cart, inventoryResponse) {
    var variants = inventoryResponse && inventoryResponse.variants;
    var adjustments = {};
    var i;

    if (!variants || typeof variants !== 'object') {
      return null;
    }

    for (i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      var stock = readReportedStock(variants, item.variant_id);
      if (stock === null) {
        continue;
      }
      if (stock < item.quantity) {
        adjustments[item.variant_id] = stock;
      }
    }

    return adjustments;
  }

  // A variant the inventory service has not propagated yet is returned as 0,
  // which is indistinguishable from a real out-of-stock. Confirm with Shopify
  // before removing the line. If Shopify still says available, or we cannot
  // confirm, keep the line and let checkout enforce live stock.
  function confirmZeroAdjustments(cart, adjustments) {
    var ids = Object.keys(adjustments).filter(function (id) {
      return Number(adjustments[id]) === 0;
    });
    var byHandle = {};
    var i;

    if (!ids.length) {
      return $.Deferred().resolve(adjustments).promise();
    }

    for (i = 0; i < ids.length; i++) {
      var id = ids[i];
      var item = null;
      var j;

      for (j = 0; j < cart.items.length; j++) {
        if (String(cart.items[j].variant_id) === String(id)) {
          item = cart.items[j];
          break;
        }
      }

      if (!item || !item.handle) {
        delete adjustments[id];
        continue;
      }

      if (!byHandle[item.handle]) {
        byHandle[item.handle] = [];
      }
      byHandle[item.handle].push(id);
    }

    var handles = Object.keys(byHandle);
    if (!handles.length) {
      return $.Deferred().resolve(adjustments).promise();
    }

    return $.when.apply($, handles.map(function (handle) {
      return $.ajax({
        url: '/products/' + encodeURIComponent(handle) + '.js',
        dataType: 'json',
        timeout: PRODUCT_CONFIRM_TIMEOUT_MS
      }).then(function (product) {
        var variants = (product && product.variants) || [];
        byHandle[handle].forEach(function (variantId) {
          var available = null;
          var v;

          for (v = 0; v < variants.length; v++) {
            if (String(variants[v].id) === String(variantId)) {
              available = variants[v].available === true;
              break;
            }
          }

          if (available !== false) {
            delete adjustments[variantId];
          }
        });
      }, function () {
        byHandle[handle].forEach(function (variantId) {
          delete adjustments[variantId];
        });
      });
    })).then(function () {
      return adjustments;
    });
  }

  function releaseCheckout(cart) {
    inventoryChecked = true;
    setCheckoutLoading(false);
    setCheckoutProgress(100);

    if (pendingCheckout) {
      pendingCheckout = false;

      if (!isReviewConfirmed()) {
        highlightReviewStep();
        return $.Deferred().resolve(cart).promise();
      }

      window.location.href = '/checkout';
    }

    return $.Deferred().resolve(cart).promise();
  }

  function processInventoryResponse(cart, inventoryResponse) {
    var adjustments = collectInventoryAdjustments(cart, inventoryResponse);

    if (!adjustments) {
      return releaseCheckout(cart);
    }

    return confirmZeroAdjustments(cart, adjustments).then(function (confirmed) {
      adjustments = confirmed;

      if (!Object.keys(adjustments).length) {
        return releaseCheckout(cart);
      }

      return applyInventoryAdjustments(cart, adjustments);
    });
  }

  function applyInventoryAdjustments(cart, adjustments) {
    var i;

    setCheckoutProgress(75);

    return $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      dataType: 'json',
      contentType: 'application/json',
      timeout: INVENTORY_TIMEOUT_MS,
      data: JSON.stringify({ updates: adjustments })
    }).then(function (updatedCart) {
      var keys = Object.keys(adjustments);
      var html = '';

      for (i = 0; i < keys.length; i++) {
        var variantId = parseInt(keys[i], 10);
        var newQuantity = adjustments[variantId];
        var originalItem = null;
        var originalQuantity = 0;

        for (var j = 0; j < cart.items.length; j++) {
          if (cart.items[j].variant_id === variantId) {
            originalItem = cart.items[j];
            originalQuantity = cart.items[j].quantity;
            break;
          }
        }

        if (originalItem) {
          html += buildAdjustmentItemHtml(originalItem, originalQuantity, newQuantity);
        }
      }

      renderCart(updatedCart);
      $header.trigger('cartcount:update', { response: updatedCart });
      $inventoryAdjustments.html(html);
      setCheckoutProgress(100);
      setCheckoutLoading(false);
      inventoryChecked = true;
      pendingCheckout = false;
      openInventoryModal();
      return updatedCart;
    }, function () {
      return releaseCheckout(cart);
    });
  }

  function checkInventoryNow(runCheckoutAfter) {
    var finished = false;

    pendingCheckout = !!runCheckoutAfter;
    inventoryChecked = false;
    updateCheckoutState();
    setCheckoutLoading(true);
    setCheckoutProgress(0);

    function finish(handler) {
      if (finished) {
        return $.Deferred().resolve(currentCart).promise();
      }
      finished = true;
      return handler();
    }

    return $.ajax({
      url: '/cart.js',
      dataType: 'json',
      timeout: INVENTORY_TIMEOUT_MS
    })
      .then(function (cart) {
        currentCart = cart;
        setCheckoutProgress(10);

        if (!cart.item_count) {
          return finish(function () {
            pendingCheckout = false;
            inventoryChecked = true;
            setCheckoutLoading(false);
            updateCheckoutState();
            return $.Deferred().resolve(cart).promise();
          });
        }

        var variantIDs = cart.items.map(function (item) {
          return item.variant_id;
        });
        var queryString = variantIDs.map(function (id, index) {
          return (index ? '&' : '') + 'id[]=' + id;
        }).join('');

        setCheckoutProgress(20);

        return $.ajax({
          url: settings.inventoryEndpoint + '/api/variant-inventory?' + queryString,
          dataType: 'json',
          timeout: INVENTORY_TIMEOUT_MS
        }).then(function (response) {
          if (finished) {
            return currentCart;
          }
          setCheckoutProgress(50);
          return processInventoryResponse(cart, response).then(function (result) {
            finished = true;
            return result;
          }, function () {
            return finish(function () {
              return releaseCheckout(currentCart);
            });
          });
        });
      })
      .then(null, function () {
        return finish(function () {
          return releaseCheckout(currentCart);
        });
      });
  }

  function checkInventory(runCheckoutAfter) {
    if (runCheckoutAfter && !isReviewConfirmed()) {
      highlightReviewStep();
      return $.Deferred().reject().promise();
    }

    return enqueueCartTask(function () {
      return checkInventoryNow(runCheckoutAfter);
    });
  }

  function openCartNow(options) {
    options = options || {};

    function showDrawer(cart) {
      if (!cart) {
        return cart;
      }

      var wasOpen = isOpen;

      if (!isOpen) {
        isOpen = true;
        $cart.addClass('is-open').attr('aria-hidden', 'false');
        $('body').addClass('ajax-cart-open no-scroll');
      }

      if (!wasOpen) {
        resetDrawerChrome();
      } else {
        scheduleDrawerChromeSync();
      }

      if (!cart.item_count) {
        return cart;
      }

      return checkInventoryNow(false);
    }

    if (options.cart) {
      renderCart(options.cart);
      $header.trigger('cartcount:update', { response: options.cart });

      if (!isOpen) {
        resetReviewConfirmation();
      }

      return $.Deferred().resolve(options.cart).promise().then(showDrawer).then(function () {
        if (isOpen) {
          $cart.find('.ajax-cart__close').first().trigger('focus');
        }
      });
    }

    if (isOpen) {
      return refreshCart().then(showDrawer);
    }

    resetReviewConfirmation();

    return refreshCart().then(showDrawer).then(function () {
      if (isOpen) {
        $cart.find('.ajax-cart__close').first().trigger('focus');
      }
    });
  }

  function openCart(options) {
    return enqueueCartTask(function () {
      return openCartNow(options);
    });
  }

  function closeCart() {
    isOpen = false;
    summaryManuallyExpanded = false;
    unlockDrawerChromeSync();
    $cart.removeClass('is-open').attr('aria-hidden', 'true');
    $('body').removeClass('ajax-cart-open no-scroll');
  }

  function isCartItemsAtTop() {
    var body = $cartBody.get(0);
    if (!body) {
      return true;
    }
    return body.scrollTop <= SCROLL_TOP_THRESHOLD;
  }

  function getLayoutHeight($el) {
    var el = $el && $el.get(0);
    if (!el) {
      return 0;
    }

    var rect = el.getBoundingClientRect();
    var styles = window.getComputedStyle(el);
    return rect.height + (parseFloat(styles.marginTop) || 0) + (parseFloat(styles.marginBottom) || 0);
  }

  function getChromeReclaim(collapseShipping, collapseSummary) {
    var reclaim = 0;

    if (
      collapseShipping &&
      $shippingBar.length &&
      !$shippingBar.prop('hidden') &&
      !$shippingBar.hasClass('is-collapsed')
    ) {
      reclaim += getLayoutHeight($shippingBar);
    }

    if (collapseSummary && $summary.length && !$summary.hasClass('is-collapsed')) {
      reclaim += getLayoutHeight($summary) - COLLAPSED_ITEMS_PADDING_BUMP;
    }

    return Math.max(0, reclaim);
  }

  function willCollapseKeepOverflow(reclaim) {
    var body = $cartBody.get(0);
    if (!body) {
      return false;
    }

    if (reclaim <= 0) {
      return body.scrollTop > SCROLL_TOP_THRESHOLD;
    }

    var nextMaxScroll = body.scrollHeight - body.clientHeight - reclaim;
    var nextScrollTop = Math.min(body.scrollTop, Math.max(0, nextMaxScroll));

    return nextMaxScroll > SCROLL_TOP_THRESHOLD + COLLAPSE_OVERFLOW_BUFFER &&
      nextScrollTop > SCROLL_TOP_THRESHOLD;
  }

  function setSummaryExpanded(expanded) {
    $summary.toggleClass('is-collapsed', !expanded);
    $summary.toggleClass('is-pinned', !!summaryManuallyExpanded && expanded);
    $summaryToggle.attr('aria-expanded', expanded ? 'true' : 'false');
  }

  function unlockDrawerChromeSync() {
    drawerChromeLocked = false;
    if (drawerChromeLockTimer) {
      window.clearTimeout(drawerChromeLockTimer);
      drawerChromeLockTimer = null;
    }
  }

  function lockDrawerChromeSync() {
    drawerChromeLocked = true;

    if (drawerChromeLockTimer) {
      window.clearTimeout(drawerChromeLockTimer);
    }

    drawerChromeLockTimer = window.setTimeout(function () {
      drawerChromeLocked = false;
      drawerChromeLockTimer = null;
      if (isOpen) {
        scheduleDrawerChromeSync();
      }
    }, CHROME_TRANSITION_MS);
  }

  function syncDrawerChrome() {
    if (drawerChromeLocked) {
      return;
    }

    var atTop = isCartItemsAtTop();
    var wantShippingCollapsed = !atTop;
    var wantSummaryCollapsed = !atTop && !summaryManuallyExpanded;
    var reclaim = getChromeReclaim(wantShippingCollapsed, wantSummaryCollapsed);

    if (!atTop && !willCollapseKeepOverflow(reclaim)) {
      wantShippingCollapsed = false;
      wantSummaryCollapsed = false;
    }

    var shippingWasCollapsed = $shippingBar.hasClass('is-collapsed');
    var summaryWasCollapsed = $summary.hasClass('is-collapsed');

    $shippingBar.toggleClass('is-collapsed', wantShippingCollapsed);

    if (atTop) {
      summaryManuallyExpanded = false;
    }

    setSummaryExpanded(!wantSummaryCollapsed);

    if (
      shippingWasCollapsed !== wantShippingCollapsed ||
      summaryWasCollapsed !== wantSummaryCollapsed
    ) {
      lockDrawerChromeSync();
    }
  }

  function scheduleDrawerChromeSync() {
    if (drawerChromeFrame) {
      window.cancelAnimationFrame(drawerChromeFrame);
    }

    drawerChromeFrame = window.requestAnimationFrame(function () {
      drawerChromeFrame = null;
      syncDrawerChrome();
    });
  }

  function resetDrawerChrome() {
    summaryManuallyExpanded = false;
    unlockDrawerChromeSync();
    if ($cartBody.length) {
      $cartBody.scrollTop(0);
    }
    scheduleDrawerChromeSync();
  }

  function interceptFlyout() {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) {
            return;
          }

          var $node = $(node);
          if ($node.is('[data-atc-banner]') || $node.find('[data-atc-banner]').length) {
            $('[data-atc-banner]').remove();
            openCart();
          }
        });
      });
    });

    observer.observe(document.body, { childList: true });
  }

  $document.on('click', '[data-ajax-cart-open], .site-header-cart--button', function (event) {
    event.preventDefault();
    openCart();
  });

  $cart.on('click', '[data-ajax-cart-close]', function (event) {
    event.preventDefault();
    var shouldResetBuyForm = $(this).is('[data-ajax-cart-continue], .ajax-cart__continue');
    closeCart();
    if (shouldResetBuyForm) {
      $(document).trigger('ajaxcart:continue');
    }
  });

  $cart.on('keydown', function (event) {
    if (event.key === 'Escape') {
      closeCart();
    }
  });

  $cartBody.on('scroll', function () {
    scheduleDrawerChromeSync();
  });

  $summaryToggle.on('click', function () {
    var expanded = !$summary.hasClass('is-collapsed');

    if (expanded) {
      summaryManuallyExpanded = false;
      setSummaryExpanded(false);
      lockDrawerChromeSync();
      return;
    }

    summaryManuallyExpanded = !isCartItemsAtTop();
    setSummaryExpanded(true);
    lockDrawerChromeSync();
  });

  $noteToggle.on('click', function () {
    var expanded = $(this).attr('aria-expanded') === 'true';
    $(this).attr('aria-expanded', expanded ? 'false' : 'true');
    $(this).toggleClass('is-open', !expanded);
    $notePanel.prop('hidden', expanded);
  });

  $noteField.on('input', function () {
    clearTimeout(noteSaveTimer);
    var note = $(this).val();

    noteSaveTimer = setTimeout(function () {
      saveCartNote(note);
    }, 500);
  });

  $reviewCheckbox.on('change', function () {
    if ($reviewConfirm.length) {
      $reviewConfirm.removeClass('is-highlighted');
    }
    updateCheckoutState();
  });

  $items.on('change', '[data-cartitem-quantity]', function () {
    var $item = $(this).closest('[data-cartitem-id]');
    var variantId = $item.data('cartitem-id');
    var quantity = parseInt($(this).val(), 10) || 0;
    $cart.find('[data-ajax-cart-error]').remove();
    changeItem(variantId, quantity);
  });

  $items.on('click', '[data-cartitem-qty-increase]', function (event) {
    event.preventDefault();
    var $item = $(this).closest('[data-cartitem-id]');
    var $input = $item.find('[data-cartitem-quantity]');
    var quantity = parseInt($input.val(), 10) || 0;
    $cart.find('[data-ajax-cart-error]').remove();
    changeItem($item.data('cartitem-id'), quantity + 1);
  });

  $items.on('click', '[data-cartitem-qty-decrease]', function (event) {
    event.preventDefault();
    var $item = $(this).closest('[data-cartitem-id]');
    var $input = $item.find('[data-cartitem-quantity]');
    var quantity = parseInt($input.val(), 10) || 0;
    $cart.find('[data-ajax-cart-error]').remove();
    changeItem($item.data('cartitem-id'), Math.max(quantity - 1, 0));
  });

  $items.on('click', '[data-cartitem-remove]', function (event) {
    event.preventDefault();
    var $item = $(this).closest('[data-cartitem-id]');
    $cart.find('[data-ajax-cart-error]').remove();
    changeItem($item.data('cartitem-id'), 0);
  });

  $checkoutButton.on('click', function (event) {
    event.preventDefault();

    if ($checkoutButton.hasClass('loading')) {
      return;
    }

    if (!inventoryChecked) {
      return;
    }

    if (!isReviewConfirmed()) {
      highlightReviewStep();
      return;
    }

    var proceed = function () {
      checkInventory(true);
    };

    if (settings.enableOrderNotes && $noteField.length) {
      saveCartNote($noteField.val()).always(proceed);
    } else {
      proceed();
    }
  });

  $inventoryModal.on('click', '[data-action="close"]', function (event) {
    event.preventDefault();
    closeInventoryModal();
  });

  $header.on('cartcount:update', function (event, data) {
    if (data && data.response) {
      updateTotals(data.response);
    }
  });

  window.AjaxCart = {
    open: openCart,
    close: closeCart,
    refresh: refreshCart,
    addItems: addItems,
    checkInventory: checkInventory,
    registerProductUrl: registerProductUrl,
    registerVariantUrl: registerVariantUrl,
    registerVariantUrls: registerVariantUrls
  };

  loadProductUrlMap();
  seedCompareAtFromSettings();
  harvestCompareAtFromDom();
  seedCompareAtFromProduct();
  interceptFlyout();
  updateTotals(currentCart);
  applyColorSwatches();

  ensureCompareAtPrices(currentCart).then(function (didUpdate) {
    if (didUpdate && currentCart && currentCart.items && currentCart.items.length) {
      renderCart(currentCart, { skipCompareAtFetch: true });
    }
  });

  var colorSwatchAttempts = 0;
  var colorSwatchTimer = setInterval(function () {
    applyColorSwatches();
    seedUrlsFromCurrentProduct();
    seedCompareAtFromProduct();
    saveProductUrlMap();
    colorSwatchAttempts += 1;

    if (
      colorSwatchAttempts > 20 ||
      (
        window._colors &&
        window._colors.colors &&
        (!settings.parentProductUrl || (window._product && window._product.variants))
      )
    ) {
      clearInterval(colorSwatchTimer);
    }
  }, 500);
  }

  $(initAjaxCart);
})(jQuery);
